'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarButtons = renderWithRef('PriceBarButtons', null, (e, o)=>{
    let { children: s } = e;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: new Set([
            'swan-price-bar-buttons'
        ]),
        props: e,
        children: s
    });
});

export { PriceBarButtons };
